import React, { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';

import { Button, Select, Spacer, Table, Text } from 'components';
import { Field, Form, Formik } from 'formik';
import { downloadcsv } from 'helpers/downloadcsv';
import { useQuery } from 'hooks/useQuery';
import { PageTitle } from 'pages/Layout/PageTitle';
import { conferenceService } from 'services';
import * as yup from 'yup';

const columns = [
  { label: 'NF de Entrada', align: 'center' },
  { label: 'Serviço', align: 'center' },
  { label: 'Modelo', align: 'center' },
  { label: 'Serial', align: 'center' },
  { label: 'Patrimônio', align: 'center' },
  { label: 'Status', align: 'center' },
  { label: 'NF de Saída', align: 'center' },
  { label: 'Operador Logístico', align: 'center' },
];

export const validationSchema = yup.object().shape({
  nota: yup.string().required(),
  type: yup.number().required(),
});

export const IngLogGetReport = () => {
  const [ingLogData, setIngLogData] = useState([]);

  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [clients, , loadingClients] = useQuery(() => conferenceService.getCliente(), []);

  const clientOptions = (clients || []).map((client) => ({
    label: client.label,
    value: client.value,
  }));

  const formattedIngLogData = (ingLogData || []).filter((data) => {
    const searchTerm = search.toLocaleLowerCase();

    const serial = data?.['SerialNumberIn']?.toLocaleLowerCase();

    return serial?.includes(searchTerm);
  });

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExportReport = async (values) => {
    try {
      const { data } = await conferenceService.getIngLogGetReport(values);
      setIngLogData(data);

      if (data.length === 0) {
        toast.error('Sem dados para exportar');
        return;
      }

      downloadcsv('ing_log_get', data);
      toast.success('Relatório gerado com sucesso');
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <PageTitle>ING LOG GETNET - Recebimento</PageTitle>
      <Formik
        initialValues={{
          nota: '',
          type: '',
        }}
        onSubmit={handleExportReport}
        validationSchema={validationSchema}
      >
        {(props) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={2}>
                <Field
                  size='small'
                  name='nota'
                  label='Digite a Nota'
                  type='text'
                  variant='outlined'
                  component={Text}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <Field
                  size='small'
                  name='type'
                  label='Cliente'
                  variant='outlined'
                  options={clientOptions}
                  loading={loadingClients}
                  component={Select}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <Button
                  fullWidth
                  type='submit'
                  disabled={!props.dirty || !props.isValid}
                  loading={props.isSubmitting}
                >
                  Exportar
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>

      <Spacer size={32} />

      {formattedIngLogData.length > 0 && (
        <Grid container spacing={2}>
          <Grid item sm={4}>
            <Text
              label='Pesquisar'
              size='small'
              variant='outlined'
              endAdornment={<SearchIcon />}
              value={search}
              onChange={handleSearchChange}
            />
          </Grid>
          <Grid item sm={12}>
            <Table
              headers={columns}
              maxHeight
              striped
              emptyMessage='Nenhuma dado encontrado'
              data={formattedIngLogData}
              page={page}
              rowsPerPage={rowsPerPage}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              disableNumeration
            >
              {formattedIngLogData?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell align='center'>{item?.['Nota Fiscal Entrada']}</TableCell>
                  <TableCell align='center'>{item?.['Tipo de Serviço']}</TableCell>
                  <TableCell align='center'>{item?.['Modelo']}</TableCell>
                  <TableCell align='center'>{item?.['SerialNumberIn']}</TableCell>
                  <TableCell align='center'>{item?.['Patrimônio']}</TableCell>
                  <TableCell align='center'>{item?.['Status']}</TableCell>
                  <TableCell align='center'>{item?.['Nota Fiscal Saída']}</TableCell>
                  <TableCell align='center'>{item?.['Operador Logístico']}</TableCell>
                </TableRow>
              ))}
            </Table>
          </Grid>
        </Grid>
      )}
    </>
  );
};
